import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a5c0dafe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a5c0dafe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c0dafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5c0dafe')) {
      api.createRecord('a5c0dafe', component.options)
    } else {
      api.reload('a5c0dafe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a5c0dafe&scoped=true&", function () {
      api.rerender('a5c0dafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83M8h9S4UjSHY/JS/comp/GuestBox.vue"
export default component.exports